module.exports = __webpack_public_path__ + "ff23b49e1753b4b2291859275d186301.svg";